@layer design-system {
  .styledLinePlot {
    path[data-line-plot-path] {
      stroke-width: 2;
    }
  }

  .typePositive {
    color: var(--viz-bullish);
  }

  .typeNegative {
    color: var(--viz-bearish);
  }

  .typeMedian {
    color: var(--border-default);
  }
}
